import { create } from 'zustand';
import { toast } from 'react-hot-toast';

export const useNotificationStore = create((set) => ({
  message: null,
  type: 'error', // Puede ser 'error', 'success', 'warning', 'info'
  
  setNotification: (message, type = 'error') => {
    if (message) {
      switch (type) {
        case 'success':
          toast.success(message);
          break;
        case 'warning':
          toast(message, { icon: '⚠️' });
          break;
        case 'info':
          toast(message);
          break;
        default:
          toast.error(message);
      }
    }
    set({ message, type });
  },
  clearNotification: () => set({ message: null }),
}));
